import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './ClanTag.css'

const propTypes = {
    tag: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    emblem: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
}

const defaultProps = {
    size: 'small',
}

class ClanTag extends React.PureComponent {

    render() {
        const classNameBase = classNames(styles.base, {
            [styles[`base__${this.props.size}`]]: this.props.emblem,
        })
        const emblem = this.props.emblem && (<img className={styles.emblem} src={this.props.emblem} />)

        return (
            <div className={classNameBase} style={{ color: this.props.color }}>
                {emblem}
                [{this.props.tag}]
            </div>
        )
    }
}

ClanTag.defaultProps = defaultProps
ClanTag.propTypes = propTypes

export default ClanTag



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/ClanTag/ClanTag.jsx